import { useCallback } from 'react';
import { useRecoilState } from 'recoil';
import { userStore } from 'stores/userStore';
import { UserSettings } from 'types/userSettings';

export function useMemberAuthorization() {
	const [loginSettings] = useRecoilState(userStore.loginSettings);

	const getIsSelectedMemberTheUserById = useCallback(
		(selectedMemberId?: number) => {
			if (!loginSettings?.userId || !selectedMemberId) {
				return false;
			}
			return loginSettings?.userId === selectedMemberId;
		},
		[loginSettings?.userId]
	);

	const getIsSelectedMemberTheUserByMember = useCallback(
		(selectedMember: UserSettings | UserSettings[] | null) => {
			if (!loginSettings?.userId || !selectedMember) {
				return false;
			}
			if (Array.isArray(selectedMember)) {
				const isSelectedMemberTheUser = selectedMember.find(member => member.id === loginSettings?.userId);
				if (isSelectedMemberTheUser) {
					return true;
				}
			}
			return (selectedMember as UserSettings).id === loginSettings?.userId;
		},
		[loginSettings?.userId]
	);

	return { getIsSelectedMemberTheUserById, getIsSelectedMemberTheUserByMember };
}
